import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

import IResponse = ZoneIQCalibration.IResponse;

const API = environment.ZONEIQ_CALIBRATION + '/v1/zoning-code';

export enum ExternalLinkStatus {
    VALIDATION = 'VALIDATION',
    PROVIDED = 'PROVIDED',
    NOT_PROVIDED = 'NOT_PROVIDED'
}

@Injectable({
    providedIn: 'root'
})
export class ExternalLinkService {
    private externalLink: string = null;

    private readonly statusSubject = new BehaviorSubject<ExternalLinkStatus>(ExternalLinkStatus.VALIDATION);
    readonly status = this.statusSubject.asObservable();

    get ExternalLink() {
        return this.externalLink || '';
    }

    constructor(private readonly location: Location, private readonly http: HttpClient) {}

    private checkToken(token: string) {
        const isDraftPage = this.isDraftPage();
        const isZCImportPage = this.isZCImportPage();
        if (!isDraftPage && !isZCImportPage) {
            return;
        }

        let params = new HttpParams();
        if (isDraftPage) {
            params = params.append('isDraft', 'true');
        }

        return this.http
            .get<IResponse>(`${API}/${token}/validate`, { params })
            .pipe(map(response => Number.isInteger(response.data)));
    }

    validateToken() {
        const externalLink = this.getDraftPageExternalLink() || this.getZCImportPageExternalLink();

        if (!externalLink) {
            return;
        }
        this.checkToken(externalLink).subscribe(status => {
            if (status) {
                this.externalLink = externalLink;
                this.statusSubject.next(ExternalLinkStatus.PROVIDED);
            } else {
                this.statusSubject.next(ExternalLinkStatus.NOT_PROVIDED);
            }
        });
    }

    private getDraftPageExternalLink(): string {
        const [, section, externalLink] = this.location.path().split('/');

        return section && section === 'draft' && externalLink;
    }

    private getZCImportPageExternalLink(): string {
        const [, importSection, section, externalLink] = this.location.path().split('/');

        return importSection && importSection === 'import' && section && section === 'zoning-code' && externalLink;
    }

    isDraftPage(): boolean {
        const [, section] = this.location.path().split('/');

        return section === 'draft';
    }

    isImportSection(): boolean {
        const [, section] = this.location.path().split('/');

        return section === 'import';
    }

    isZCImportPage(): boolean {
        const [, importSection, section] = this.location.path().split('/');

        return importSection === 'import' && section === 'zoning-code';
    }

    // isZCImportUseLabelsPage(): boolean {
    //     return (
    //         this.isImportSection() &&
    //         this.location
    //             .path()
    //             .split('/')
    //             .includes('calibration-uses-labels')
    //     );
    // }

    isZCImportUseValuesPage(): boolean {
        return (
            this.isImportSection() &&
            this.location
                .path()
                .split('/')
                .includes('uses')
        );
    }
}
